const Icon: React.FC<IconProps> = ({ color = "white", width = "26px", height = "26px" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="13" cy="13" r="11.25" stroke={color} strokeWidth="1.5" />
      <path d="M15.136 19.6661C13.9032 20.0612 12.5849 20.1066 11.3278 19.7973C10.0707 19.4881 8.92392 18.8362 8.01505 17.9143C7.10618 16.9924 6.47078 15.8364 6.17949 14.575C5.8882 13.3136 5.95243 11.9961 6.36504 10.769L13 13L15.136 19.6661Z" fill={color} />
      <path d="M10.6721 6.39842C11.893 5.96789 13.2094 5.88437 14.475 6.15716C15.7405 6.42994 16.9056 7.04834 17.8408 7.94361C18.7759 8.83888 19.4445 9.97595 19.7721 11.2284C20.0998 12.4809 20.0737 13.7997 19.6967 15.0382L13 13L10.6721 6.39842Z" fill={color} />
    </svg>
  );
};

export default Icon;
